export default __webpack_public_path__ + "images/UnionPay.41fd54d21d6153936cbe1fea960749f6.svg";